import { Box, MenuItem, TextField, Typography } from '@mui/material';

// Settings for the "Gutschein erhöhen" block: raises the vouchers of an earlier
// issueVoucher block atomically to the target amount — same code, same PIN,
// same expiry. Already-redeemed vouchers are never touched.
const IncreaseVoucherSettings = ({ block, blocks = [], readOnly, onConfigChange }) => {
  const config = block.config || {};
  const voucherBlocks = blocks.filter(candidate => candidate.type === 'issueVoucher');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        select
        size='small'
        label='Gutschein aus Block'
        value={config.voucherBlockId || ''}
        disabled={readOnly}
        onChange={event => onConfigChange({ voucherBlockId: event.target.value || null })}
      >
        <MenuItem value=''>Kein Block ausgewählt</MenuItem>
        {voucherBlocks.map(candidate => (
          <MenuItem key={candidate.blockId} value={candidate.blockId}>
            Gutschein erstellen ({Number(candidate.config?.amount) || 0} €) — {candidate.blockId}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        key={`${block.blockId}-amount`}
        size='small'
        type='number'
        label='Zielwert (€)'
        defaultValue={Number(config.amount) || 30}
        disabled={readOnly}
        inputProps={{ min: 1 }}
        onChange={event => {
          const parsed = Number(event.target.value);
          onConfigChange({ amount: Number.isFinite(parsed) && parsed > 0 ? parsed : 30 });
        }}
        sx={{ width: 140 }}
      />
      <Typography variant='caption' color='text.secondary'>
        Erhöht den bestehenden Gutschein atomar auf den Zielwert — Code, PIN und Ablaufdatum bleiben
        gleich. Bereits eingelöste oder abgelaufene Gutscheine werden übersprungen, ein Wettlauf mit
        einer parallelen Einlösung ist ausgeschlossen. Danach den GetResponse-Sync erneut ausführen,
        damit das Wert-Feld in GetResponse aktuell ist.
      </Typography>
    </Box>
  );
};

export default IncreaseVoucherSettings;
